import JWTdecode from 'jwt-decode';

export const isAuthenticated = (token: string) => {
  const { exp } = JWTdecode(token);
  return exp && exp * 1000 > Date.now();
};
